import { Suspense, lazy, useState } from "react";
import NewsList from "@/components/news/NewsList";
import FeedToolbar from "@/components/news/FeedToolbar";
import ActiveFilterPills from "@/components/news/ActiveFilterPills";
import { PageShell } from "@/components/layout/PageShell";
import Seo from "@/components/seo/Seo";
import { useT } from "@/i18n/useLocale";

// Loaded on demand: most visitors never open the sign-in window.
const AuthModal = lazy(() => import("@/components/auth/AuthModal"));

const Index = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const t = useT();

  return (
    <>
      <Seo title={t("home.title")} description={t("home.subtitle")} path="/" />
      <PageShell>
        <h1 className="sr-only sm:not-sr-only sm:text-lg sm:font-bold sm:tracking-tight sm:text-foreground">
          {t("home.title")}
        </h1>
        <p className="hidden sm:block text-sm text-muted-foreground pb-2">{t("home.subtitle")}</p>
        <FeedToolbar />
        <ActiveFilterPills />
        <div className="py-4">
          <h2 className="sr-only">{t("home.latest")}</h2>
          <NewsList />
        </div>
      </PageShell>
      {isAuthModalOpen && (
        <Suspense fallback={null}>
          <AuthModal isOpen onClose={() => setIsAuthModalOpen(false)} />
        </Suspense>
      )}
    </>
  );
};

export default Index;
